import React, { useState, useCallback } from 'react';
import { useDidMount } from '@surveycake/rhooks';
import { Message } from '@surveycake/rc';
import { domain } from 'config/system';
import { getReportToken } from 'app/core/http';
import { useSurveyConfig } from 'app/core/survey-config';
import { Button } from 'app/shared/components';

export interface PublicResultProps {
  className: string;
}

/**
 * Only on `thankyou` page and `show_result` config is true.
 */
export default function PublicResult({ className }: PublicResultProps) {
  const surveyConfig = useSurveyConfig();
  const {
    surveyHash,
    data: { language, show_result: showResult },
    wording
  } = surveyConfig;
  const [pending, setPending] = useState(false);
  const [token, setToken] = useState('');
  const onClick = useCallback(() => {
    if (surveyConfig.isPreview()) {
      Message.info(wording.common.preview.no_view_result, { duration: 2000 });
    } else if (token) {
      const url = `${
        domain.server
      }/admin/${language!}/survey/${surveyHash}/report?v=${token}&layout=P`;
      window.location.href = url;
    }
  }, [surveyConfig, wording, token, language, surveyHash]);

  useDidMount(async () => {
    if (!showResult || surveyConfig.isPreview()) {
      return;
    }

    try {
      setPending(true);
      const newToken = await getReportToken(surveyHash);
      setToken(newToken);
      setPending(false);
    } catch (error) {
      setPending(false);
    }
  });

  if (!showResult) {
    return null;
  }

  return (
    <Button
      className={className}
      color="primary"
      onClick={onClick}
      loading={pending}
    >
      {wording.common.action.view_result}
    </Button>
  );
}
